module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAABFElEQVQ4T42Ta0oDQRCEq+ZInsQjCKLTC4JIErNEIggmYiIiBJxuPIxn8gLbMiG75MFmp/9Of1RN1QxROCmlOckrluyr6gvJZwDLQSCltAghzACsYozTs4CZvQGom6ZZVlX1lN30Amb2DuBxf7kXUNU1ybG7z0Xkdf+eJwpm9gFg5O4zEcmWDuYAMLNPAA/uXotItnQyHaCqXyTvs+8Y47ov7i1gZhsAd+4+EpGs0jvcRTd19/HQ8jYlVf0D8CsilyWttwp1iZ2uh5TSdwihcveJiORY++/QnrRQUUrHUFEPLaSqiaQUNb2DcnJK8rboLR1DRa/1HDT047K9H5LXRT8uK7l7LtdI3gBYDCl0Bapqhi7+AXtUl/IU9tR8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/back.png
// module id = +bkr
// module chunks = 0